import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuth } from '../lib/auth'

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    const user = useAuth.getState().user
    if (user) {
      throw redirect({ to: '/my-ideas' })
    }
    throw redirect({ to: '/login' })
  },
})
